import ImageCaption from './ImageCaption'

export default ImageCaption



// WEBPACK FOOTER //
// ./src/components/ImageCaption/index.js